var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-accordion",
    { attrs: { title: _vm.pageTitle, isTitleUpperCase: false } },
    [
      _c(
        "b-row",
        { staticClass: "form-group" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("common.global.client")))]),
              _vm._v(" "),
              _c("b-form-checkbox-group", {
                attrs: {
                  id: "checkbox-group-1",
                  disabled: _vm.readonly,
                  options: _vm.listVerifClientSSL,
                  stacked: "",
                },
                model: {
                  value: _vm.selectedVerif,
                  callback: function ($$v) {
                    _vm.selectedVerif = $$v
                  },
                  expression: "selectedVerif",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("common.global.server")))]),
              _vm._v(" "),
              _c("b-form-checkbox-group", {
                attrs: {
                  id: "checkbox-group-2",
                  disabled: _vm.readonly,
                  options: _vm.listVerifServerSSL,
                  stacked: "",
                },
                model: {
                  value: _vm.selectedVerif,
                  callback: function ($$v) {
                    _vm.selectedVerif = $$v
                  },
                  expression: "selectedVerif",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }